import React from 'react';
import { Laptop, BookOpen, Users, TrendingUp } from 'lucide-react';

const HowWeHelpSection = () => {
  const steps = [
    {
      icon: <Laptop className="h-8 w-8 text-blue-600" />,
      title: "Hands-On Labs",
      description: "Work with real technology in our state-of-the-art learning environment"
    },
    {
      icon: <BookOpen className="h-8 w-8 text-green-600" />,
      title: "Real Projects",
      description: "Build your portfolio with industry-relevant projects and challenges"
    },
    {
      icon: <Users className="h-8 w-8 text-purple-600" />,
      title: "Expert Mentorship",
      description: "Learn from experienced professionals who've walked your path"
    },
    {
      icon: <TrendingUp className="h-8 w-8 text-yellow-600" />,
      title: "Career Support",
      description: "Get guidance on job applications, interviews, and career growth"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            How Does CareerLift Help?
          </h2>
          <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto leading-relaxed">
            Practical experience with personalized support every step of the way
          </p>
        </div>

        {/* Feature Image */}
        <div className="mb-16">
          <img 
            src="https://images.unsplash.com/photo-1758518731027-78a22c8852ec?w=1200&q=85" 
            alt="Student success with laptop"
            className="rounded-2xl shadow-2xl max-w-4xl mx-auto hover-lift"
          />
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="text-center p-6"
            >
              <div className="inline-flex p-4 bg-blue-50 rounded-lg mb-6">
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
              <p className="text-gray-600 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowWeHelpSection;